import React, { useEffect, useState, lazy, memo } from 'react';
import { StarIcon, ThumbsUpIcon, MessageCircleIcon } from 'lucide-react';
const Testimonials = () => {
  // Estado para el testimonio destacado
  const [activeTestimonial, setActiveTestimonial] = useState(0);
  // Estado para el contador de "me gusta"
  const [likes, setLikes] = useState({
    0: 37,
    1: 42,
    2: 29
  });
  // Estado para controlar si el usuario ya dio like
  const [userLiked, setUserLiked] = useState({
    0: false,
    1: false,
    2: false
  });
  // Rotar testimonios automáticamente
  useEffect(() => {
    const testimonialTimer = setInterval(() => {
      setActiveTestimonial(prev => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(testimonialTimer);
  }, []);
  // Función para dar like a un testimonio
  const handleLike = id => {
    if (!userLiked[id]) {
      setLikes(prev => ({
        ...prev,
        [id]: prev[id] + 1
      }));
      setUserLiked(prev => ({
        ...prev,
        [id]: true
      }));
    }
  };
  const testimonials = [{
    id: 0,
    quote: 'No lo creí hasta que lo probé. Lloré de alivio.',
    name: 'María G.',
    location: 'Barcelona',
    stars: 5,
    image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=761&q=80',
    date: 'Hace 3 semanas',
    detail: 'Después de 7 años sufriendo migrañas, finalmente encontré algo que me ayuda sin efectos secundarios.'
  }, {
    id: 1,
    quote: 'Llevo meses sin tomar analgésicos.',
    name: 'Carlos P.',
    location: 'Madrid',
    stars: 5,
    image: 'https://images.unsplash.com/photo-1492562080023-ab3db95bfbce?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1148&q=80',
    date: 'Hace 1 mes',
    detail: 'Mi médico estaba sorprendido de cómo mejoré. Ya no dependo de medicamentos para funcionar.'
  }, {
    id: 2,
    quote: 'Mi calidad de vida mejoró desde el día uno.',
    name: 'Laura M.',
    location: 'Sevilla',
    stars: 5,
    image: 'https://images.unsplash.com/photo-1554151228-14d9def656e4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=686&q=80',
    date: 'Hace 2 meses',
    detail: 'Puedo trabajar, hacer ejercicio y disfrutar de mi familia sin ese dolor constante. Es liberador.'
  }];
  // Pre-render stars array to avoid re-computation
  const renderStars = count => {
    return Array(count).fill(0).map((_, i) => <StarIcon key={i} size={16} className="text-[#f59e0b] fill-[#f59e0b]" data-id="element-392" />);
  };
  const featuredStars = Array(5).fill(0).map((_, i) => <StarIcon key={i} size={24} className="text-[#f59e0b] fill-[#f59e0b] mx-1" data-id="element-393" />);
  // Indicador de verificación
  const verifiedBadge = <div className="bg-[#f0f9ff] text-[#0284c7] text-xs font-medium px-2 py-1 rounded-full flex items-center" data-id="element-394">
      <svg className="w-3 h-3 mr-1 text-[#0284c7] fill-current" viewBox="0 0 20 20" data-id="element-395">
        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-396"></path>
      </svg>
      Verificado
    </div>;
  return <section id="testimonials" className="py-16 md:py-24 bg-white" data-id="element-397">
      <div className="container mx-auto px-4 md:px-6" data-id="element-398">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-399">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-[#1e293b]" data-id="element-400">
            Miles ya lo hicieron
          </h2>
          <p className="text-xl text-[#4a5568]" data-id="element-401">
            Estas son solo algunas de las más de 12,000 personas que han
            recuperado su vida sin dolor
          </p>
          {/* Estadísticas de satisfacción */}
          <div className="flex flex-wrap justify-center gap-8 mt-8" data-id="element-402">
            <div className="bg-[#f8f9ff] p-4 rounded-lg flex items-center" data-id="element-403">
              <div className="mr-3" data-id="element-404">
                <div className="text-3xl font-bold text-[#6366f1]" data-id="element-405">97%</div>
                <div className="text-sm text-[#4a5568]" data-id="element-406">Satisfacción</div>
              </div>
              <div className="flex" data-id="element-407">{renderStars(5)}</div>
            </div>
            <div className="bg-[#f8f9ff] p-4 rounded-lg flex items-center" data-id="element-408">
              <div className="mr-3" data-id="element-409">
                <div className="text-3xl font-bold text-[#6366f1]" data-id="element-410">4.8/5</div>
                <div className="text-sm text-[#4a5568]" data-id="element-411">Calificación</div>
              </div>
              <div className="flex" data-id="element-412">{renderStars(5)}</div>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-413">
          {testimonials.map(testimonial => <div key={testimonial.id} className={`bg-[#f8f9ff] rounded-xl shadow-md p-6 transition-all duration-300 ${activeTestimonial === testimonial.id ? 'transform scale-105 border-2 border-[#6366f1] shadow-lg' : 'hover:shadow-lg hover:transform hover:scale-105'}`} data-id="element-414">
              <div className="flex justify-between items-start mb-4" data-id="element-415">
                <div className="flex items-center" data-id="element-416">
                  <img src={testimonial.image} alt={testimonial.name} className="w-12 h-12 rounded-full object-cover mr-4 border-2 border-white shadow-sm" width="48" height="48" loading="lazy" data-id="element-417" />
                  <div data-id="element-418">
                    <div className="flex items-center" data-id="element-419">
                      <h4 className="font-semibold text-[#1e293b]" data-id="element-420">
                        {testimonial.name}
                      </h4>
                      {verifiedBadge}
                    </div>
                    <p className="text-sm text-[#718096]" data-id="element-421">
                      {testimonial.location} • {testimonial.date}
                    </p>
                  </div>
                </div>
                <div className="flex" data-id="element-422">{renderStars(testimonial.stars)}</div>
              </div>
              <blockquote className="text-lg text-[#4a5568] italic mb-4" data-id="element-423">
                "{testimonial.quote}"
              </blockquote>
              <p className="text-sm text-[#4a5568] mb-4" data-id="element-424">
                {testimonial.detail}
              </p>
              {/* Botones de interacción */}
              <div className="flex justify-between items-center mt-4 pt-4 border-t border-[#e2e8f0]" data-id="element-425">
                <button onClick={() => handleLike(testimonial.id)} className={`flex items-center text-sm ${userLiked[testimonial.id] ? 'text-[#6366f1] font-medium' : 'text-[#718096] hover:text-[#6366f1]'}`} data-id="element-426">
                  <ThumbsUpIcon size={16} className="mr-1" data-id="element-427" />
                  <span data-id="element-428">Útil ({likes[testimonial.id]})</span>
                </button>
                <div className="text-sm text-[#718096] flex items-center" data-id="element-429">
                  <MessageCircleIcon size={16} className="mr-1" data-id="element-430" />
                  <span data-id="element-431">3 respuestas</span>
                </div>
              </div>
            </div>)}
        </div>
        <div className="mt-16 flex justify-center" data-id="element-432">
          <div className="bg-[#eef2ff] rounded-xl p-6 md:p-8 max-w-3xl relative" data-id="element-433">
            {/* Indicador de testimonio destacado */}
            <div className="absolute -top-3 -left-3 bg-[#6366f1] text-white text-xs font-bold py-1 px-3 rounded-full shadow" data-id="element-434">
              DESTACADO
            </div>
            <div className="flex items-center justify-center mb-6" data-id="element-435">
              {featuredStars}
            </div>
            <p className="text-xl md:text-2xl text-center text-[#1e293b] font-medium" data-id="element-436">
              "Después de 7 años de migrañas crónicas, por fin puedo decir que
              tengo días completos sin dolor. Este dispositivo cambió mi vida."
            </p>
            <div className="mt-6 text-center" data-id="element-437">
              <div className="flex items-center justify-center mb-2" data-id="element-438">
                <img src="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80" alt="Ana Rodríguez" className="w-16 h-16 rounded-full object-cover border-4 border-white shadow-md" data-id="element-439" />
              </div>
              <h4 className="font-semibold text-[#1e293b]" data-id="element-440">Ana Rodríguez</h4>
              <p className="text-[#718096]" data-id="element-441">Usuaria desde hace 6 meses</p>
            </div>
            {/* Contador de personas que experimentaron resultados similares */}
            <div className="mt-6 text-center" data-id="element-442">
              <p className="text-sm text-[#6366f1]" data-id="element-443">
                <strong data-id="element-444">1,247 personas</strong> reportaron resultados similares
                en los últimos 30 días
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default memo(Testimonials);